import type { Mode } from "src/utils/types/mode";
import { UNSAFE_featureConfigEscapeHatch } from "../feature/UNSAFE_useConfigureFeatureEscapeHatch";
import {
  type CustomDimensions,
  type GaPageConfig,
  configureAnalytics,
} from "./configureAnalytics";
import type { ScreenLocations } from "./getLocations/getLocations";
import type { Screen } from "./generateScreenComponentsRendered/Screen";
import type { ScreenComponent } from "./generateScreenComponentsRendered/ScreenComponent";
import { updateSessionInfo } from "./useAnalyticsCoreExperience/session";

export function sendAnalyticsPageView(
  pageConfig: GaPageConfig,
  customDimensions?: CustomDimensions,
  screen?: Screen,
  modes?: Mode[],
  components?: ScreenComponent[],
  locations?: ScreenLocations,
) {
  updateSessionInfo();

  // Analytics has to be configured before sending a PageView so that the correct
  // page information is attributed to the PageView and all subsequent Analytics events (until
  // Analytics is configured again).
  configureAnalytics({
    pageConfig,
    customDimensions,
    locations,
    screen,
    modes,
    components,
  });

  !!window.snowplow && window.snowplow("trackPageView");

  if (
    UNSAFE_featureConfigEscapeHatch.LogAnalyticsEventsToConsole ||
    UNSAFE_featureConfigEscapeHatch.Debug
  ) {
    logPageViewToConsole(pageConfig);
  }
}

function logPageViewToConsole(config: GaPageConfig) {
  console.log(
    `» %cSp Pageview %c${config.pagePath} %c${config.pageLocation}`,
    "color:green;",
    "color:blue;",
    "color:#48104d;",
  );
}
